export const headers = [
  { field: "id", headerName: "ID", width: 70, hidden: true },
  { field: "nombre", headerName: "Nombre", width: 180 },
  { field: "descripcion", headerName: "Descripcion", width: 280 },
  ];
  